import { httpClient } from "@coworker/http-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { SelectedItems } from "../../multi-order-addons/context/selectedItemsReducer";
import { getRefillAreaIdFromLocation } from "@fixa/store-locations";
import {
  COMPLETED_TASKS_QUERY_KEY,
  IN_PROGRESS_TASKS_QUERY_KEY,
  OPEN_TASKS_QUERY_KEY,
  OVERVIEW_TASKS_QUERY_KEY,
} from "../../TasksOverview/constants/queryKeys";

async function createTasks(tasks: SelectedItems) {
  return await httpClient.tasks.post(`/v1/tasks/create`, { body: tasks });
}

export const useCreateTasksMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: { tasks: SelectedItems }) =>
      await createTasks(data),
    onSuccess: async (data: any) => {
      if (!data || !data.body[0]) {
        return;
      }

      if (data.body[0].state === "COMPLETED") {
        await queryClient.invalidateQueries({
          queryKey: [OVERVIEW_TASKS_QUERY_KEY, COMPLETED_TASKS_QUERY_KEY],
        });

        await queryClient.invalidateQueries({
          queryKey: [
            "articlesByRefillArea",
            getRefillAreaIdFromLocation(data.body[0].location) || "",
          ],
        });
      }

      await queryClient.invalidateQueries({
        queryKey: [
          OVERVIEW_TASKS_QUERY_KEY,
          data.body[0].assigned_user_id
            ? IN_PROGRESS_TASKS_QUERY_KEY
            : OPEN_TASKS_QUERY_KEY,
        ],
      });

      return data;
    },
    onError: (error) => {
      console.log("Error while creating task", error);
    },
  });
};
